export const FATOR_DIVISAO = 3.785;

export function calcular_sugestao_em_galao(produto) {
  const qtde_valida = Number(produto.sugestao || 0);
  const litragem_valida = Number(produto.litragem || 0);

  if (produto.tipo_litragem === 'LT') {
    return qtde_valida * litragem_valida;
  }

  return (qtde_valida * litragem_valida) / FATOR_DIVISAO;
}
